import axios from 'axios';

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL || '/api/v1',
  timeout: 15000,
  headers: { 'Content-Type': 'application/json' },
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('bringhub_token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use(
  (response) => response,
  (error) => {
    const isLoginRequest = error.config?.url?.includes('/auth/login');
    if (error.response?.status === 401 && !isLoginRequest) {
      localStorage.removeItem('bringhub_token');
      localStorage.removeItem('bringhub_user');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

// Extrai a mensagem de erro do envelope { success, message } ou fallback genérico
export function extractApiError(err, fallback = 'Erro inesperado') {
  const d = err.response?.data;
  return d?.message || d?.error || fallback;
}

export default api;
